<template>
  <div class="sky-delivery-deploy-project-view" v-show="isShow">
    <!-- <toolbar-panel></toolbar-panel> -->
    <content-panel
      :projectId="projectId"
      :stage="flowStatus"
      :createBytmp="createBytmp"
      :industryId="industryId"
      :customer="customer"
    ></content-panel>
  </div>
</template>
<script>
import viewController from 'sky-engine/views/viewController'

import contentPanel from './contentPanel'

export default {
  name: 'DeliveryDeployPojectDetail',
  inject: ['DeliveryDeployDetail'],
  components: {
    // toolbarPanel,
    contentPanel
  },
  extends: viewController,
  props: {
    views: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      projectId: this.DeliveryDeployDetail.views.params.projectId,
      customer: this.DeliveryDeployDetail.views.params.customer,
      flowStatus: this.DeliveryDeployDetail.views.params.flowStatus,
      industryId: this.DeliveryDeployDetail.views.params.industryId,
      createBytmp: this.DeliveryDeployDetail.views.params.createBytmp
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/mixin/mixin';
@import '~sky-engine/assets/styles/common/var.scss';
@include b(delivery-deploy-project-view) {
  height: 100%;
}
</style>
